export const DEFAULT_MODULE = 'support';
export const MODULE_STORAGE_KEY = 'ai-agents:selected-module';
